export default __webpack_public_path__ + "static/media/no_app_found.d6bb493d.svg";